import { render } from "./RespiratoryTestsPreview.vue?vue&type=template&id=5abc4109"
import script from "./RespiratoryTestsPreview.vue?vue&type=script&lang=js"
export * from "./RespiratoryTestsPreview.vue?vue&type=script&lang=js"

import "./RespiratoryTestsPreview.vue?vue&type=style&index=0&id=5abc4109&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/panels/testsPreview/RespiratoryTestsPreview.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5abc4109"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5abc4109', __exports__)) {
    console.log('reload')
    api.reload('5abc4109', __exports__)
  }
  
  module.hot.accept("./RespiratoryTestsPreview.vue?vue&type=template&id=5abc4109", () => {
    console.log('re-render')
    api.rerender('5abc4109', render)
  })

}


export default __exports__